export const authActionTypes = {
  ADD_UID: "ADD_UID",
  ADD_USER: "ADD_USER",
  SET_NEW_USER: "SET_NEW_USER",
  LOGOUT: "LOGOUT",
};
